const getInitials = (name: string): string => {
  const n = name.trim();
  const parts = n.split(' ');

  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`;
  }

  return n ? n.substr(0, 2) : n;
};

export default getInitials;
